import { render, staticRenderFns } from "./CompanySearchDetail.vue?vue&type=template&id=67172323"
import script from "./CompanySearchDetail.vue?vue&type=script&lang=js"
export * from "./CompanySearchDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanySearchDetail.vue?vue&type=style&index=0&id=67172323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports